import { capitalize } from 'lodash';
import GuestWaiver from '../../../GuestWaiver';
import { useMultiTierCheckout } from '../../context';
import { StepProps, StepsId } from '../../types';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

import styles from '../../../Checkout.module.scss';

const WaiversStep = ({ goToStep }: StepProps) => {
  const {
    data: {
      checkoutSession: { isLoadingCheckout, checkoutError, confirmCheckout },
      paymentMethod,
      waivers
    },
    onSuccess
  } = useMultiTierCheckout();

  const goToConfirmStep = () => {
    waivers.setTotalCheckedWaivers(0);
    goToStep(StepsId.ConfirmTransactionStep);
  };

  const onConfirmCheckout = () => {
    confirmCheckout({ allWaiversAccepted: waivers.allWaiversAccepted }).then(
      () => {
        onSuccess();
        goToStep(StepsId.SuccessStep);
      }
    );
  };

  let buttonText = null;
  if (paymentMethod.selectedBuyNowPayLater.value) {
    buttonText = `Continue to ${capitalize(
      paymentMethod.selectedBuyNowPayLater.value
    )}  ${waivers.totalCheckedWaivers}/${waivers.data.length}`;
  } else {
    buttonText = `Confirm & Pay ${waivers.totalCheckedWaivers}/${waivers.data.length}`;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.column}>
        <div className="px-5">
          <GuestWaiver
            onGoBack={goToConfirmStep}
            waivers={waivers.data}
            setCheckedWaiverCount={waivers.setTotalCheckedWaivers}
            waiverStyle={
              checkoutError?.message ? 'max-h-[75vh] md:max-h-[450px]' : ''
            }
          />
          <div className={styles.nextButtonWrapperMulti}>
            {checkoutError?.message && (
              <div className="text-error text-center pb-2">
                {checkoutError.message}
              </div>
            )}
            <Button
              onClick={onConfirmCheckout}
              disabled={!waivers.allWaiversAccepted}
              type={ButtonType.Primary}
              loading={isLoadingCheckout}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaiversStep;
